var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "runningplanView",
      attrs: {
        title: "班次详情",
        visible: _vm.drawer,
        "before-close": _vm.handleBeforeClose,
        width: "80%",
        "element-loading-text": "正在加载中～",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { padding: "15px" } },
        [
          _c(
            "el-form",
            { attrs: { size: "small" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  !_vm.needHide
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["transport_runningplan_edit"],
                              expression: "['transport_runningplan_edit']",
                            },
                          ],
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleEdit(_vm.info)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      )
                    : _vm._e(),
                  _vm.runningPlanEditShowDialog
                    ? _c("running-plan-edit", {
                        ref: "runningplanEdit",
                        on: { refreshDetailsData: _vm.refresh },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "班次类型：" } }, [
                _vm._v(_vm._s(_vm.info.flightType)),
              ]),
              _vm.info.adjustTime < 0
                ? _c("el-form-item", { attrs: { label: "时间：" } }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.info.otherDate) +
                          " " +
                          _vm._s(_vm.info.otherTime) +
                          "-" +
                          _vm._s(
                            _vm.info.spanDay ? _vm.info.departureDate : ""
                          ) +
                          "\n          " +
                          _vm._s(_vm.info.departureTime)
                      ),
                    ]),
                  ])
                : _c("el-form-item", { attrs: { label: "时间：" } }, [
                    _vm._v(_vm._s(_vm.info.time)),
                  ]),
              _c("el-form-item", { attrs: { label: "供应商：" } }, [
                _vm._v(_vm._s(_vm.info.merchantName)),
              ]),
              _c("el-form-item", { attrs: { label: "班次状态：" } }, [
                _vm._v(_vm._s(_vm.info.flightStatus)),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "归属线路：" } },
                [
                  _c("yd-link", {
                    attrs: {
                      value: _vm.info.lineName,
                      permi: "transport_bound_info",
                      type: "merchantDetal",
                      need: true,
                      query: {
                        id: _vm.info.merchantPriceId,
                        merchantName: _vm.info.merchantName,
                      },
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "价格方案：" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c("div", { staticStyle: { "margin-right": "20px" } }, [
                      _vm._v(_vm._s(_vm.info.priceMethodName)),
                    ]),
                    !_vm.needHide
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "text" },
                            on: { click: _vm.changePrice },
                          },
                          [_vm._v("修改价格")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "运力信息：" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: _vm.info.capacityInfoVOS,
                                size: "mini",
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "出车顺序",
                                  align: "center",
                                  prop: "sort",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "状态",
                                  align: "center",
                                  prop: "driverStatus",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "司机姓名",
                                  align: "center",
                                  prop: "driverName",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "司机电话",
                                  align: "center",
                                  width: "120",
                                  prop: "driverPhoneNum",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "车牌号",
                                  align: "center",
                                  prop: "carNum",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c("yd-link", {
                                          attrs: {
                                            value: row.carNum,
                                            permi: "vehicle_manage",
                                            need: true,
                                            type: "vehicleDetail",
                                            query: { id: row.carId },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "车型",
                                  align: "center",
                                  prop: "carType",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { label: "操作时间", align: "center" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.capacityTime
                                          ? _c("div", [
                                              _vm._v(
                                                _vm._s(scope.row.capacityTime)
                                              ),
                                            ])
                                          : _c("div", [_vm._v("——")]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          !_vm.needHide
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["transport_runningplan_adjust"],
                                      expression:
                                        "['transport_runningplan_adjust']",
                                    },
                                  ],
                                  attrs: { size: "small", type: "text" },
                                  on: { click: _vm.handlemodify },
                                },
                                [
                                  _vm._v(
                                    "\n              调整运力\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "tipsBox" }, [
                            _c("img", {
                              staticStyle: { width: "20px", height: "20px" },
                              attrs: { src: require("./static/tips.png") },
                            }),
                            _c("span", [
                              _vm._v("点击调整运力可更换城际司机！"),
                            ]),
                          ]),
                          _vm.modifyDriverDialog
                            ? _c("modify-driver", {
                                ref: "modifyDriver",
                                on: {
                                  refreshData: function ($event) {
                                    return _vm.getDetail(_vm.flightPlanId)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "站点信息：" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "90%" },
                      attrs: {
                        data: _vm.info.stationInfoVOS,
                        size: "mini",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "序号", align: "center", prop: "sort" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "类型",
                          type: "index",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.$index === 0
                                  ? _c("div", [_vm._v("起点")])
                                  : scope.$index === _vm.end
                                  ? _c("div", [_vm._v("终点")])
                                  : _c("div", [_vm._v("经过")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "站点名称",
                          align: "center",
                          prop: "stationName",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "是否开启站点",
                          align: "center",
                          prop: "isOpen",
                          width: "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "到达时间",
                          align: "center",
                          width: "120",
                          prop: "arrTime",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "里程数（公里）",
                          align: "center",
                          prop: "mileage",
                          width: "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "上下车规则",
                          align: "center",
                          prop: "rule",
                          width: "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "起售时间",
                          align: "center",
                          prop: "startTime",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "停售时间",
                          align: "center",
                          prop: "endTime",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "接送类型",
                          align: "center",
                          prop: "pickUpType",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "是否开启接送",
                          align: "center",
                          prop: "openPickUp",
                          width: "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "是否发车点",
                          align: "center",
                          prop: "isShow",
                          width: "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.isShow === 1 ? "是" : "否")
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "接送规则",
                          align: "center",
                          prop: "pickUpRule",
                          fixed: "right",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "right",
                                      width: "580",
                                      trigger: "click",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        attrs: {
                                          data: scope.row.transportRule,
                                          height: "400",
                                          border: "",
                                          size: "small",
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            width: "120",
                                            prop: "serviceArea",
                                            align: "center",
                                            label: "服务区域",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            width: "120",
                                            prop: "pickUpRule",
                                            align: "center",
                                            label: "接送方式",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            width: "120",
                                            prop: "priceTypeRule",
                                            align: "center",
                                            label: "接送模式",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return _vm._l(
                                                    _vm.transportModeDic,
                                                    function (item) {
                                                      return _c(
                                                        "span",
                                                        { key: item.value },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                item.value ===
                                                                  scope.row
                                                                    .priceTypeRule
                                                                  ? item.label
                                                                  : ""
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  )
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "pickUpTime",
                                            align: "center",
                                            label: "接人时间",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "recommendStation",
                                            align: "center",
                                            label: "推荐站点",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          type: "text",
                                          size: "small",
                                        },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            "已开启 " +
                                              scope.row.transportRule.length +
                                              " 个区域接送"
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "例检单：" } },
                [
                  _vm.drawer
                    ? _c("upload-image", {
                        attrs: {
                          file: _vm.fileList,
                          code: "custom-flight",
                          isMultiple: true,
                          disabled: _vm.needHide,
                        },
                        on: {
                          uploadSuccess: _vm.getCarImgList,
                          remove: _vm.getCarImgList,
                        },
                      })
                    : _vm._e(),
                  !_vm.needHide
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["transport_runningplan_upload"],
                              expression: "['transport_runningplan_upload']",
                            },
                          ],
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.submitFile },
                        },
                        [_vm._v("\n          上传例检单\n        ")]
                      )
                    : _vm._e(),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisible,
                        "append-to-body": true,
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.dialogVisible = $event
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: { width: "100%", src: _vm.imageUrl, alt: "" },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.priceShow ? _c("priceView", { ref: "priceview" }) : _vm._e(),
      _c(
        "el-button",
        {
          staticStyle: { margin: "20px 0 10px 0" },
          attrs: { loading: _vm.logLoading, size: "small", type: "primary" },
          on: { click: _vm.showLogData },
        },
        [
          _vm._v("操作日志\n    "),
          !_vm.showLog
            ? _c("i", { staticClass: "el-icon-arrow-right" })
            : _c("i", { staticClass: "el-icon-arrow-down" }),
        ]
      ),
      _c(
        "transition",
        { attrs: { name: "el-fade-in-linear" } },
        [
          _c("operation-log", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showLog,
                expression: "showLog",
              },
            ],
            attrs: { visible: _vm.showLog, flightPlanId: _vm.flightPlanId },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }